var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6806 18.5487C23.8027 18.5487 27.9549 14.3964 27.9549 9.27434C27.9549 4.15226 23.8027 0 18.6806 0C13.5585 0 9.40625 4.15226 9.40625 9.27434C9.40625 14.3964 13.5585 18.5487 18.6806 18.5487Z",
    fill: "#4F4E4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4516 20.7247L26.9002 25.5004H21.8791C20.5156 25.5004 19.3089 26.3756 18.889 27.6728C18.4669 28.9679 18.9288 30.3867 20.0316 31.1867L24.0935 34.1392L22.5421 38.915C22.12 40.21 22.5819 41.6288 23.6825 42.4288C24.7852 43.231 26.277 43.231 27.3798 42.4288L31.4417 39.4785L35.5036 42.4288C36.6064 43.231 38.0981 43.231 39.2009 42.4288C40.3015 41.6288 40.7634 40.21 40.3413 38.915L38.7899 34.1392L42.8518 31.1867C43.9546 30.3867 44.4165 28.9679 43.9943 27.6728C43.5745 26.3756 42.3678 25.5004 41.0043 25.5004H35.9832L34.4318 20.7247C34.0119 19.4296 32.803 18.5522 31.4417 18.5522C30.0803 18.5522 28.8715 19.4296 28.4516 20.7247Z",
    fill: "#AD4EFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1963 43.0262C20.0659 42.0374 20.1094 40.9972 20.3474 39.9955L21.2504 36.2105L18.889 33.8699C17.2852 32.2812 16.6127 29.4668 17.2266 26.8971C17.8387 24.3248 19.5955 22.5867 21.5791 22.5867H24.4977L24.8038 21.307C23.0809 20.9491 21.2542 20.7534 19.3632 20.7534C13.0876 20.7534 7.5318 22.8931 4.08232 26.0989C1.45082 28.545 0 31.6529 0 34.9153V38.6489C0 39.8101 0.338147 40.9251 0.940767 41.7439C1.54339 42.5653 2.35947 43.0262 3.21145 43.0262H20.1963Z",
    fill: "#4F4E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomericon);
export default __webpack_public_path__ + "static/media/customericon.043c99f7f7a03b7152c57b29b0ae520e.svg";
export { ForwardRef as ReactComponent };